import { createContext } from "react";

const CampaignContext = createContext();

export default CampaignContext;
